import { render, staticRenderFns } from "./hotels.vue?vue&type=template&id=0e0470ca&"
import script from "./hotels.vue?vue&type=script&lang=js&"
export * from "./hotels.vue?vue&type=script&lang=js&"
import style0 from "./hotels.vue?vue&type=style&index=0&id=0e0470ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports